export default {
  EQUALS: '===',
  GREATER_THAN: '>',
  GREATER_THAN_EQUAL_TO: '>=',
  SMALLER_THAN: '<',
  SMALLER_THAN_EQUAL_TO: '<=',
  BETWEEN: '><',
  STARTS_WITH: 'a%',
  CONTAINS: '%a%',
};
